import type { Environment } from '@/constants/Environments';
import EnvironmentHelper from '@/classes/EnvironmentHelper/EnvironmentHelper';

export const copyAsset = (
  environment: Environment,
  accessToken: string,
  type: string,
  userId: string,
  id: string,
) => {
  EnvironmentHelper.setEnvironment(environment);

  const urlParams = new URLSearchParams({
    method: 'CopyAsset',
    copyTo: userId,
    assetId: id,
    assetType: type,
  });
  const url = `${EnvironmentHelper.getLegacyApiUrl()}?${urlParams.toString()}`;
  const header = new Headers({
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json; charset=utf-8',
  });
  return fetch(url, {
    method: 'POST',
    headers: header,
  }).then(
    (res) =>
      res.json() as unknown as {
        status: 'success' | string;
        info: {
          id: string;
        };
      },
  );
};
